import React, { Component } from 'react';
import Loader from './Loader';

const CourseDetailsLoader = () => (
  <div className="row no-gutters">
    <div className="col-lg-12">
      <div className="card">
        <div className="card-header">
          <div className="row no-gutters">
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 p-2">
              About Course
            </div>
          </div>
        </div>
        <div className="card-body min-h-700">
          <div className="row p-60">
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 p-0 m-0">
              <h1>
                <Loader width="350" height="50" />
                <Loader width="350" height="50" />
                <Loader width="350" height="50" />
              </h1>
              <div className="row">
                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                  <div className="description-title">
                    <Loader width="250" height="60" />
                  </div>
                  <p className="description-text">
                    <Loader width="250" height="60" />
                  </p>
                </div>
                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                  <div className="description-title">
                    <Loader width="250" height="60" />
                  </div>
                  <p className="description-text">
                    <Loader width="250" height="60" />
                  </p>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                  <div className="description-title">
                    {' '}
                    <Loader width="250" height="60" />
                  </div>
                  <p className="description-text">
                    {' '}
                    <Loader width="250" height="60" />
                  </p>
                </div>
                <div className="col-xs-12 col-sm-5 col-md-5 col-lg-5">
                  <div className="description-title">
                    {' '}
                    <Loader width="250" height="60" />
                  </div>
                  <p className="description-text">
                    {' '}
                    <Loader width="250" height="60" />
                  </p>
                </div>
              </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 ">
              <div className="description-title">
                <Loader width="350" height="30" />
              </div>
              <div className="brief-heading">
                {' '}
                <Loader width="250" height="30" />
              </div>
              <p>
                <Loader width="400" height="200" />
              </p>
              <p>
                <Loader width="400" height="200" />
              </p>
              <div className="link-container">
                <Loader width="300" height="20" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* card for outstanding fees */}
    </div>
  </div>
);

export default CourseDetailsLoader;
